import React, { useState, useEffect } from 'react';
import  { useNavigate } from 'react-router-dom'
import ThaivivatLogo from '../components/ThaivivatLogo.js'


import imgClaimPaper from '../images/inform/img_claim_paper.png'

import InformNotifyNoComponent from '../components/InformNotifyNoComponent.js'
import InformSelectCarComponent from '../components/InformSelectCarComponent.js'
import InformUploadDocComponent from '../components/InformUploadDocComponent.js'


function InformPage() {

  const navigate = useNavigate();

  const [ isShowNotify, setIsShowNotify ] = useState(true)
  const [ isShowSelectCar, setIsShowSelectCar ] = useState(false)
  const [ isShowUploadDoc, setIsShowUploadDoc ] = useState(false)

  const [ carLisenceList, setCarLisenceList ] = useState([])
  const [ notifyNo, setNotifyNo ] = useState("")

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])



  function showNotifyForm(){
    setIsShowNotify(true)
    setIsShowSelectCar(false)
    setIsShowUploadDoc(false)
  }

  function showSelectCarForm(){
    setIsShowNotify(false)
    // next step
    setIsShowSelectCar(true)
    setIsShowUploadDoc(false)
  }

  function showUploadDocrForm(){
    setIsShowNotify(false)
    // next step
    setIsShowSelectCar(false)
    setIsShowUploadDoc(true)
  }


  function onCheckNotifySuccess( licenses ){
    setCarLisenceList( licenses )
    showSelectCarForm(  )
  }
  function onCheckNotifyFail(){
    
  }

  function onSelectCarSuccess(  ){
    gotoNewInform( )
  }
  function onSelectCarFail(){
    
  }
  


  function onUploadDocSuccess(){
    showUploadDocrForm()
  }
  function onUploadDocFail(){
    
  }

  function onUploadDocAction(){
    showUploadDocrForm()
  }


  function onCreateNewInform(){
    showNotifyForm()
  }


  function gotoNewInform(  ){
    navigate("/inform/new")
  }

  return (
  <div className="w-full bg-white font-prompt ">
      <div className="flex flex-wrap w-full bg-white font-prompt">

      

          <div className={'hidden md:flex flex-wrap w-1/2 justify-center px-4 md:px-0 bg-green-500'}>
            
            <div className=" w-full bg-green-500 pt-8 pl-8">
              <div className=''>
                <ThaivivatLogo></ThaivivatLogo>
              </div>
            </div>
              
            <div className={' w-full   justify-center  md:px-0 items-center'}>
              <div className='md:flex flex-wrap w-full '>
                
                <div className='flex flex-wrap w-full justify-center align-middle '>
                  <div className='flex-wrap w-[428px] pt-10 px-11'>

                    <div className='flex-wrap w-full'>
                      <span className='flex w-full text-xl font-medium text-white'>เลขรับแจ้งอยู่ตรงไหน?</span>
                      <span className='flex w-full mt-2 text-base font-normal leading-5 text-grey-700'>ตำแหน่งจะอยู่มุมขวาบน ตรงช่องกรอกที่เขียนว่า “เลขรับแจ้งที่” ให้คุณเอาเลขนั้นมากรอก</span>
                    </div>

                    <div className='flex  w-[440px]  justify-center mt-11'>
                      <img src={imgClaimPaper} alt="banner-claim-paper" className='flex w-[440px] h-[348px]' />
                    </div>

                  </div>  

                </div>
              </div>

            </div>
          </div>

          <div className={'flex  flex-wrap w-full md:w-1/2 h-screen  bg-white  overflow-y-auto'}>
            <div className={'flex w-full  h-screen justify-center md:items-center'}>
                
                {
                  (isShowNotify)?
                    <InformNotifyNoComponent onSuccess={onCheckNotifySuccess} onFail={onCheckNotifyFail} onUploadDocAction={onUploadDocAction}  />
                    :
                    null
                }
                {
                  (isShowSelectCar)?
                    <InformSelectCarComponent data={carLisenceList} onSuccess={onSelectCarSuccess} onFail={onSelectCarFail} onUploadDocAction={onUploadDocAction} onBack={showNotifyForm} /> 
                    :
                    null
                }
                {
                  (isShowUploadDoc)?
                    <InformUploadDocComponent onSuccess={onUploadDocSuccess} onFail={onUploadDocFail} onCreateNewInform={onCreateNewInform} />
                    :
                    null
                }

            </div>
          </div>
      </div>
  </div>
  )
}


export default InformPage;